<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">产品</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">我的域名</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div v-if="activeNames === 'index'" class="se-panel-title">域名列表</div>
        <div v-if="activeNames === 'rztemplate'">
          <el-button plain icon="el-icon-arrow-left" @click="activeNames = 'index'"></el-button>
          <span class="se-panel-title z-padding-left-5-precent ver-sub">域名列表</span>
        </div>
        <div v-if="activeNames === '35renzheng'">
          <el-button plain icon="el-icon-arrow-left" @click="activeNames = 'index'"></el-button>
          <span class="se-panel-title z-padding-left-5-precent ver-sub">域名列表</span>
        </div>
      </div>
      <div v-if="activeNames === 'index'">
        <div class="panel-body clearfix">
          <div class="alert-warn">
            如果域名为.com/.net/.cn类型，模板审核通过后，通过该模板注册的域名将会自动实名。
            <br>
            其他类型的域名，注册后，每个域名需要单独提交实名资料。
          </div>
          <div class="ub-box z-margin-bottom-20-precent">
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="BuyDomain">注册域名</el-button>
            <div class="zj-select" style="margin-left: 25px">
              <el-input placeholder="搜索域名" v-model="search" class="input-with-select" @keyup.enter.native="SearchDomain">
                <el-button slot="append" icon="el-icon-search" @click="SearchDomain"></el-button>
              </el-input>
            </div>
          </div>
          <el-table :data="domainList" highlight-current-row v-loading="listLoading" @sort-change="sort" style="width: 100%;">
            <el-table-column prop="domain" label="域名" align="left">
            </el-table-column>
            <el-table-column prop="shiming" label="实名认证" align="left">
              <template slot-scope="scope">
                <i v-if="!scope.row.shiming" class="el-icon-loading"></i>
                <span v-if="scope.row.shiming">{{scope.row.shiming}}</span>
                <el-popover trigger="hover">
                  <p>{{ scope.row.reason }}</p>
                  <span v-show="scope.row.reason" slot="reference" class="dialog-help-link name-wrapper" style="top: 12px">
                  </span>
                </el-popover>
                <span v-if="scope.row.smrz_type == 1 && (scope.row.shiming === '实名资料未上传' || scope.row.shiming === '实名资料审核拒绝')" class="z-curPonit z-color-a" @click="ModIdent(scope.row.domain)" style="margin-left: 25px;">上传实名资料</span>
                <span v-if="scope.row.org == '35' && scope.row.shiming != '实名审核通过'" class="z-curPonit z-color-a" @click="SanWuIdent(scope.row.domain)" style="margin-left: 25px;">实名认证</span>
              </template>
            </el-table-column>
            <el-table-column prop="state" label="状态（全部）" align="left">
            </el-table-column>
            <el-table-column prop="start_date" label="注册日期" align="left" sortable="custom">
            </el-table-column>
            <el-table-column prop="end_date" label="到期日期" align="left" sortable="custom">
            </el-table-column>
            <el-table-column prop="caozuo" label="操作" align="center">
              <template slot-scope="scope">
                <span class="z-curPonit z-color-a" @click="Rennew(scope.row.id,scope.row.domain,scope.row.end_date)">续费</span>
                &nbsp;&nbsp;
                <router-link :to="'/domain'+'/'+scope.row.id" class="z-color-a">管理</router-link>
              </template>
            </el-table-column>
            <span slot="empty">
            域名列表为空，
            <a class="z-curPonit z-color-a" href="/domain/" target="_blank">立即购买&gt;&gt;</a>
          </span>
          </el-table>
          <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
          </el-pagination>
          <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
          </el-pagination>
        </div>
      </div>
      <div v-if="activeNames === 'rztemplate'">
        <div class="alert-warn">
          资料提交成功后,预计3-5个工作日审核完成,审核完成状态自动更新,请您耐心等待!
        </div>
        <el-form ref="rzForm" label-width="200px" class="renzheng-form">
          <el-form-item label="域名：">
            {{rzForm.domain}}
          </el-form-item>
          <el-form-item label="注册人类型：">
            <el-radio-group v-model="rzForm.utype" size="small">
              <el-radio-button label="个人"></el-radio-button>
              <el-radio-button label="企业"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="rzForm.utype === '个人'" label="个人证件类型：">
            <el-radio-group v-model="rzForm.Type" size="small">
              <el-radio-button label="身份证"></el-radio-button>
              <el-radio-button label="护照"></el-radio-button>
              <el-radio-button label="港澳居民来往内地通行证"></el-radio-button>
              <el-radio-button label="军官证"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="rzForm.utype === '企业'" label="企业证件类型：">
            <el-radio-group  v-model="rzForm.Type" size="small">
              <el-radio-button label="组织机构"></el-radio-button>
              <el-radio-button label="营业执照"></el-radio-button>
              <el-radio-button label="信用代码"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-show="rzForm.Type === '身份证'" label="所有者身份证号：">
            <el-input v-model="rzForm.organ_code"></el-input>
          </el-form-item>
          <el-form-item v-show="rzForm.Type === '护照'" label="所有者护照号：">
            <el-input v-model="rzForm.organ_code"></el-input>
          </el-form-item>
          <el-form-item v-show="rzForm.Type === '港澳居民来往内地通行证'" label="所有者通行证号：">
            <el-input v-model="rzForm.organ_code"></el-input>
          </el-form-item>
          <el-form-item v-show="rzForm.Type === '军官证'" label="所有者军官证号：">
            <el-input v-model="rzForm.organ_code"></el-input>
          </el-form-item>
          <el-form-item v-show="rzForm.Type === '组织机构'" label="组织机构代码证代码：">
            <el-input v-model="rzForm.organ_code"></el-input>
          </el-form-item>
          <el-form-item v-show="rzForm.Type === '营业执照'" label="营业执照注册号：">
            <el-input v-model="rzForm.organ_code"></el-input>
          </el-form-item>
          <el-form-item v-show="rzForm.Type === '信用代码'" label="统一社会信用代码：">
            <el-input v-model="rzForm.organ_code"></el-input>
          </el-form-item>
          <el-form-item label=" 所有者证件照片：">
            <div class="ub-box">
              <div class="ub-box">
                <div class="col-img">
                  <label for="fileImg1" class="z-curPonit">
                    <img v-show="!showimg" src="../../assets/imgs/img3.png" alt="请上传现场图片" width="135" height="102">
                  </label>
                  <label for="fileImg1" class="z-curPonit">
                    <img v-show="showimg" :src="dataUrl" width="135" height="102"/>
                  </label>
                </div>
              </div>
              <div class="z-margin-left-15-precent">
                <p class="gff8 z-font-size-14">JPG格式，大小在50K到5M之间。</p>
                <p class="z-font-size-12 z-color-999 z-padding-bottom-5-precent">请上传证件照片，
                  <a v-show="rzForm.Type === '身份证'" href="https://img.sanfengyun.com/img/example_id_front.jpg" target="_blank" class="z-color-a">示例：身份证正反面.jpg</a>
                  <a v-show="rzForm.Type === '护照'" href="https://img.sanfengyun.com/img/example_huzhao_front.jpg" target="_blank" class="z-color-a">示例：护照正面.jpg</a>
                  <a v-show="rzForm.Type === '港澳居民来往内地通行证'" href="https://img.sanfengyun.com/img/example_txz_front.jpg" target="_blank" class="z-color-a">示例：港澳通行证正面.jpg</a>
                  <a v-show="rzForm.Type === '军官证'" href="https://img.sanfengyun.com/img/example_jgz_front.jpg" target="_blank" class="z-color-a">示例：军官证正面.jpg</a>
                  <a v-show="rzForm.Type === '组织机构'" href="https://img.sanfengyun.com/img/example_org_license.jpg" target="_blank" class="z-color-a">示例：组织机构代码证照片.jpg</a>
                  <a v-show="rzForm.Type === '营业执照'" href="https://img.sanfengyun.com/img/example_license.jpg" target="_blank" class="z-color-a">示例：营业执照照片.jpg</a>
                  <a v-show="rzForm.Type === '信用代码'" href="https://img.sanfengyun.com/img/example_trust_license.jpg" target="_blank" class="z-color-a">示例：机构信用代码证照片.jpg</a>
                </p>
                <label for="fileImg1" class="choose-file">选择文件</label>
                <input type="file" id="fileImg1" name="CertImg" @change="handleFileChange" ref="inputer" class="z-width-30-precent" style="visibility: hidden;">
              </div>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="submitrForm">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="activeNames === '35renzheng'">
        <el-form label-width="100px" style="margin-top: 20px" action="https://cp.35.com/chinese/domain_manage/domain_login.php" method="POST" target="_blank">
          <el-form-item label="域名：">
            <el-input name="race_domain" v-model="sanwu.name" readonly="readonly" auto-complete="off" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="密码：">
            <el-input name="password" v-model="sanwu.password" type="password" readonly="readonly" auto-complete="off" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="验证码：">
            <img :src="sanwu.authcode" title="点击更换验证码" style="vertical-align: top">
            请输入计算结果:
            <el-input name="authcode" v-model="sanwu.code" style="width: 60px"></el-input>
            看不清？
            <a class="z-color-a z-font-size-14" href="javascript:;" @click="ChangeCode">换一个</a>
            <input type="hidden" name="session_num" value="1413007630">
          </el-form-item>
          <el-form-item label="">
            <input type="submit"  value="管理" class="el-button el-button--small el-button--primary">
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-dialog title="域名续费" :lock-scroll="false" :visible.sync="dialogXufei" width="660px">
      <el-form label-width="180px" class="xufei-form">
        <el-form-item label="域名名称：">
          <span class="z-font-size-12 z-color-666">{{xufeiForm.domain}}</span>
        </el-form-item>
        <el-form-item label="原到期时间：">
          <span class="z-font-size-12 z-color-666">{{xufeiForm.endtime}}</span>
        </el-form-item>
        <el-form-item label="续费后到期时间：">
          <span class="z-font-size-12 z-color-666">{{xufeiForm.newtime}}</span>
        </el-form-item>
        <el-form-item label="时长：">
          <el-select v-model="xufeiForm.region">
            <el-option label="1年" value="1"></el-option>
            <el-option label="2年" value="2"></el-option>
            <el-option label="3年" value="3"></el-option>
            <el-option label="4年" value="4"></el-option>
            <el-option label="5年" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠券：">
          <el-select v-model="xufeiForm.coupon" placeholder="--请选择--" style="width: 300px">
            <el-option
              v-for="item in xufeiForm.yhq"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户余额：">
          <span class="z-font-size-12 z-color-66-orange z-font-weight-700">{{xufeiForm.money}}元</span>
        </el-form-item>
        <el-form-item label="所需费用：">
          <span v-show="xufeiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">价格计算中...</span>
          <span v-show="!xufeiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">{{xufeiForm.price}}.</span>
          <span v-show="!xufeiForm.loading" class="z-font-size-12 z-color-66-orange">00元</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogXufei = false">取 消</el-button>
        <el-button type="primary" @click="Renew">确 定</el-button>
      </div>
    </el-dialog>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import domainService from 'business/domainService.js'
  import userService from 'business/userService.js'
  import renewService from 'business/renewService.js'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        activeNames:'index',
        domainList:[],
        listLoading:false,
        dialogXufei:false,
        dialogLoading:false,
        search:'',
        order_key:'StartTime',
        order_type:'desc',
        state:[
          { text: '正常', value: '正常' },
          { text: '过期', value: '过期' },
          { text: '续费失败', value: '续费失败' },
          { text: 'CHOLD', value: 'CHOLD' },
          { text: 'SHOLD', value: 'SHOLD' },
          { text: '续费中', value: '续费中' },
          { text: '转出中', value: '转出中' },
          { text: '注册中', value: '注册中' },
          { text: '审核中', value: '审核中' },
        ],
        xufeiForm:{
          domain:'',
          endtime:'',
          newtime:'',
          region:'1',
          coupon:'',
          yhq:[],
          price:'',
          loading:false,
          money:''
        },
        rzForm:{
          domain:'',
          uname:'',
          utype:'个人',
          Type:'身份证',
          organ_code:'',
          idType:'',
        },
        showimg:false,
        count:10,
        total:0,
        page:1,
        dataUrl:'',
        sanwu:{
          name:'',
          password:'',
          code:'',
          authcode:'https://cp.35.com/chinese/validatecode.php?session_num=1413007630&time='+Math.random()
        }
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.SearchDomain()
    },
    computed: {
      region() {
        return this.xufeiForm.region
      },
      coupon() {
        return this.xufeiForm.coupon
      },
      utype() {
        return this.rzForm.utype
      }
    },
    watch:{
      region(){
        this.getPrice()
      },
      coupon(){
        this.getPrice()
      },
      utype(val,oldval){
        console.log(oldval)
        console.log(val)
        if(val === '个人'){
          this.rzForm.Type = '身份证'
        }
        if(val === '企业'){
          this.rzForm.Type = '组织机构'
        }
      }
    },
    methods:{
      ...mapActions(['DOMAIN']),
      async SearchDomain() {
        this.listLoading = true
        let data = 'cmd=domain_list'+
                   '&count='+ this.count +
                   '&page='+ this.page +
                   '&keyword='+ this.search +
                   '&order_key='+ this.order_key +
                   '&order_type='+ this.order_type
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.data.allcount
          this.domainList = vueData.data.content.map((item, index) => {
            return {
              id:item.id,
              domain:item.product_set,
              owner:item.owner,
              state:'',
              start_date:item.StartTime,
              end_date:item.EndTime,
              org:item.org,
              smrz_type:item.smrz_type,
              shiming:this.SearchShiming(item.product_set,item.org) ? false : false
          }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async SearchShiming(domain,org) {
        let data = 'cmd=smrz_query'+
          '&domain='+ domain +
          '&org='+ org
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(state.code === '000') {
          this.domainList.map((item, index) => {
            if(domain == item.domain){
              item.shiming = vueData[0].auditStatus
              item.reason = vueData[0].auditUnpassReason
            }
          })
        }else {
          this.$toast('刷新试一下','fail')
        }
      },
      BuyDomain () {
        window.open("https://www.sanfengyun.com/domain/")
      },
      sort(obj){
        switch (obj.prop) {
          case 'start_date':
            this.order_key = 'StartTime'
            break
          case 'end_date':
            this.order_key = 'EndTime'
            break
        }
        switch (obj.order) {
          case 'ascending':
            this.order_type = 'asc'
            break
          case 'descending':
            this.order_type = 'desc'
            break
        }
        this.SearchDomain()
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchDomain()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchDomain()
      },
      Rennew(id,domain,endtime) {
        this.xufeiForm.id = id
        this.xufeiForm.domain = domain
        this.xufeiForm.endtime = endtime
        this.dialogXufei = true
        this.couponInfo()
        this.getPrice()
      },
      async couponInfo() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=userinfo')
        if(state.code === '000' ) {
          this.xufeiForm.money = vueData.msg.money
          let onuse = vueData.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              label: item.yhq_id+'(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.xufeiForm.yhq = onuse.filter(items => {
            return items.yhq_use === '续费'
          })
          this.xufeiForm.yhq.unshift({
            value: '',
            label: '不使用优惠券',
            yhq_use: ''
          })
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async getPrice() {
        this.xufeiForm.loading = true
        let data = 'cmd=renew'+
          '&yewu_type=domain'+
          '&yewu_id='+ this.xufeiForm.id +
          '&renew_time='+ this.xufeiForm.region +
          '&yhq_id='+ this.xufeiForm.coupon +
          '&ac_type=getprice'
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.xufeiForm.loading = false
          this.xufeiForm.newtime = vueData.endtime
          this.xufeiForm.price = vueData.price
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async Renew() {
        this.dialogLoading = true
        let data = 'cmd=renew'+
          '&yewu_type=domain'+
          '&yewu_id='+ this.xufeiForm.id +
          '&renew_time='+ this.xufeiForm.region +
          '&yhq_id='+ this.xufeiForm.coupon +
          '&ac_type=renew'
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogXufei = false
              self.SearchDomain()
          }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      imgPreview (file) {
        let self = this;
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;

        if (/^image/.test(file.type)) {
          // 创建一个reader
          var reader = new FileReader();
          // 将图片将转成 base64 格式
          reader.readAsDataURL(file);
          // 读取成功后的回调
          reader.onloadend = function () {
            self.dataUrl = this.result;
          }
        }
        this.showimg = true
      },
      handleFileChange () {
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file  = inputDOM.files[0];
        // 这里就可以获取到文件的名字了
        this.fileName = this.file.name;

        this.imgPreview(this.file);
      },
      async submitrForm() {
        this.dialogLoading = true
        let registrantType = this.rzForm.utype === '个人' ? 'I' : 'E'
        switch (this.rzForm.Type) {
          case '身份证':
            this.rzForm.idType = 'SFZ'
            break
          case '护照':
            this.rzForm.idType = 'HZ'
            break
          case '港澳居民来往内地通行证':
            this.rzForm.idType = 'TXZ'
            break
          case '军官证':
            this.rzForm.idType = 'JGZ'
            break
          case '组织机构':
            this.rzForm.idType = 'ORG'
            break
          case '营业执照':
            this.rzForm.idType = 'YYZZ'
            break
          case '信用代码':
            this.rzForm.idType = 'TYDMZ'
            break
        }
        let formData = new window.FormData();
        formData.append('cmd', 'dn_smrz_up')
        formData.append('dn', this.rzForm.domain)
        formData.append('organ_code', this.rzForm.organ_code)
        formData.append('file_reg', this.$refs.inputer.files[0])
        formData.append('registrantType', registrantType)
        formData.append('idType', this.rzForm.idType)
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',formData)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.activeNames = 'index'
              self.SearchDomain()
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async ModIdent (domain) {
        this.activeNames = 'rztemplate'
        this.rzForm.domain = domain
      },
      async SanWuIdent (domain) {
        this.activeNames = '35renzheng'
        this.sanwu.name = domain
        let data = 'cmd=get_35_pwd'+
          '&domainname='+ domain
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.sanwu.password = vueData.msg.pwd_35
          this.sanwu.name = vueData.msg.domainname
        }else {
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      ChangeCode () {
        this.sanwu.authcode = 'https://cp.35.com/chinese/validatecode.php?session_num=1413007630&time='+Math.random()
      }
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .input-with-select .el-input-group__prepend .el-select {
    width: 90px;
  }
  .renzheng-form .el-input,.el-select {
    width: 440px;
  }
  .alert-warn {
    margin-bottom: 20px;
  }
  .col-img {
    border: solid 1px #bbbaba;
    width: 135px;
    height: 102px;
    border-radius: 3px;
    margin-right: 10px;
  }
  .choose-file {
    display: inline-block;
    position: absolute;
    padding: 4px 12px;
    margin-bottom: 0;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    color: #fff;
    border-color: #2082dd;
    background-color: #2a89e0;
    border-radius: 2px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/product/domainList.vue